import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { AddRestaurantForm } from "@/components/add-restaurant-form";
import { addRestaurant } from "@/lib/store";
import type { NewRestaurant } from "@/types";
import { deriveTasteFields } from "@/lib/rating";
import PlaceSearch from "@/components/place-search";

const AddPage = () => {
  const navigate = useNavigate();
  const [prefill, setPrefill] = useState<Partial<NewRestaurant> | undefined>(undefined);
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = (data: any) => {
    const tastePatch = deriveTasteFields(data as any);
    const ratingTasteValue = typeof tastePatch.ratingTaste === 'number'
      ? tastePatch.ratingTaste
      : (typeof data.ratingTaste === 'number' ? data.ratingTaste : 0);

    const breakdownValues = [ratingTasteValue, data.ratingAmbience, data.ratingService, data.ratingCost]
      .map((v: any) => (typeof v === 'number' && v > 0 ? v : 0));
    const hasBreakdown = breakdownValues.some((v) => v > 0);
    const count = breakdownValues.filter((v) => v > 0).length || 1;
    const derivedRating = hasBreakdown
      ? Math.round((breakdownValues.reduce((sum, val) => sum + val, 0) / count) * 10) / 10
      : undefined;
    const hasVisitEvidence = hasBreakdown || !!data.visitDate || (Array.isArray(data.visitHistory) && data.visitHistory.length > 0);

    const payload: NewRestaurant = {
      name: data.name,
      cuisine: data.cuisine,
      location: data.location,
      prefecture: data.prefecture,
      municipality: data.municipality,
      rating: typeof data.rating === 'number' && data.rating > 0 ? data.rating : (derivedRating ?? undefined),
      ratingTaste: ratingTasteValue,
      ratingTasteBalance: data.ratingTasteBalance,
      ratingTasteIngredients: data.ratingTasteIngredients,
      ratingTasteTechnique: data.ratingTasteTechnique,
      ratingTasteFine: tastePatch.ratingTasteFine ?? undefined,
      ratingTasteGrade: tastePatch.ratingTasteGrade ?? undefined,
      ratingAmbience: data.ratingAmbience,
      ratingService: data.ratingService,
      ratingCost: data.ratingCost,
      visitDate: data.visitDate,
      visitHistory: data.visitHistory,
      isWishlist: hasVisitEvidence ? false : !!data.isWishlist,
      notes: data.notes,
      image: data.image,
      priceRange: data.priceRange,
      sourceUrl: data.sourceUrl,
      tiktokUrl: data.tiktokUrl,
      confidence: data.confidence,
      id: data.id,
    };
    addRestaurant(payload);
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-background p-3 sm:p-4">
      <div className="container mx-auto max-w-3xl space-y-3">
        <PlaceSearch
          onPickImmediate={(r) => { addRestaurant(r); navigate('/'); }}
          onPickEdit={(r) => { setPrefill(r); setShowForm(true); }}
          onManual={() => { setPrefill(undefined); setShowForm(true); }}
        />
        {showForm && (
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">Step 3 内容を整えて保存</div>
            <AddRestaurantForm onSubmit={handleSubmit} onCancel={() => navigate("/")} initialData={prefill as any} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AddPage;
